module.exports = __webpack_public_path__ + "img/caissedepargne.9d536746.png";